//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Datatable from './Datatable.vue';
import Pagination from './Pagination.vue';
export default {
    props: ['company_id'],
    components: { datatable: Datatable, pagination: Pagination },
    created: function created() {
        this.getUsers();
    },
    mounted: function mounted() {},
    data: function data() {
        var listurl = listurl;
        var loading = false;
        var sortOrders = {};
        var columns = [{ class: 'col-md-2', label: 'Unternehmen', name: 'companyname', type: 'text', sortable: true }, { class: 'col-md-1', label: 'Benutzername', name: 'username', type: 'text', sortable: true }, { class: 'col-md-1', label: 'Vorname', name: 'firstname', type: 'text', sortable: true }, { class: 'col-md-1', label: 'Nachname', name: 'lastname', type: 'text', sortable: true }, { class: 'col-md-1', label: 'Usertype', name: 'usertype', type: 'text', sortable: true }, { class: 'col-md-1', label: 'Status', name: 'globalstate', type: 'email', sortable: true }, { class: 'col-md-2', label: '', name: 'actions', type: 'text', sortable: false }];
        columns.forEach(function (column) {
            sortOrders[column.name] = -1;
        });
        sortOrders['username'] = -1;
        return {
            permissions: [],
            users: [],
            columns: columns,
            sortKey: 'lastname',
            sortOrders: sortOrders,
            length: 10,
            search: '',
            tableData: {
                client: true,
                company_id: this.company_id
            },
            pagination: {
                currentPage: 1,
                total: '0',
                nextPage: '',
                prevPage: '',
                from: '',
                to: ''
            }
        };
    },

    methods: {
        getUsers: function getUsers() {
            var _this = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.protocol + "//" + window.location.hostname + "/api/users/list";

            this.loading = true;
            axios.get(url, { params: this.tableData }).then(function (response) {
                _this.loading = false;
                _this.users = response.data.users;
                _this.permissions = response.data.permissions;
                _this.pagination.total = _this.users.length;
            }).catch(function (errors) {
                console.log(errors);
            });
        },
        paginate: function paginate(array, length, pageNumber) {
            this.pagination.from = array.length ? (pageNumber - 1) * length + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPagination: function resetPagination() {
            this.pagination.currentPage = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
        sortBy: function sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        },
        getIndex: function getIndex(array, key, value) {
            return array.findIndex(function (i) {
                return i[key] == value;
            });
        },
        sendReminderMail: function sendReminderMail(userid) {
            swal({
                title: 'Erinnerungs Mail versenden ?',
                text: 'Möchten sie wirklich die Errinerungsmail versenden.',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.get("/manage/user/reminder/" + userid).then(function (response) {
                        swal({
                            title: window.i18n.messages.success,
                            html: window.i18n.messages.mail_success,
                            type: 'success',
                            timer: 1000,
                            showConfirmButton: false
                        }).then(function () {
                            //location.reload();
                        });
                    }).catch(function (error) {
                        swal({
                            title: window.i18n.messages.error,
                            html: window.i18n.messages.mail_error,
                            type: 'error'
                        });
                    });
                }
            });
        },
        oneTimePassword: function oneTimePassword(userid) {
            swal({
                title: 'Neues Password',
                text: 'Möchten sie wirklich ein neues Passwort setzten ?.',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.get("/manage/user/newpassword/" + userid).then(function (response) {
                        swal({
                            title: 'Neues Passwort',
                            html: 'Benutzername: ' + response.data.username + '<br>Neues Passwort: ' + response.data.password,
                            type: 'success',
                            showConfirmButton: true
                        }).then(function () {
                            //location.reload();
                        });
                    }).catch(function (error) {
                        swal({
                            title: window.i18n.messages.error,
                            html: window.i18n.messages.mail_error,
                            type: 'error'
                        });
                    });
                }
            });
        },
        userstate: function userstate(user) {
            if (user.globalstate.lastIndexOf('(') !== -1) {

                return user.globalstate.substring(user.globalstate.lastIndexOf('(') - 1);
            }
            return "";
        }
    },
    computed: {
        filteredUsers: function filteredUsers() {
            var _this2 = this;

            var users = this.users;
            if (this.search) {
                users = users.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(_this2.search.toLowerCase()) > -1;
                    });
                });
            }
            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                users = users.slice().sort(function (a, b) {
                    var index = _this2.getIndex(_this2.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (_this2.columns[index].type && _this2.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    } else if (_this2.columns[index].type && _this2.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    } else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                });
            }
            return users;
        },
        paginated: function paginated() {
            return this.paginate(this.filteredUsers, this.length, this.pagination.currentPage);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Users.vue
// module id = 52
// module chunks = 0